import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {TranslateService} from "../../../../shared/translate.service";


@Component({
  selector: 'app-ext-link-modal',
  templateUrl: './ext-link-modal.component.html',
  styleUrls: ['./ext-link-modal.component.scss']
})
export class ExtLinkModalComponent implements OnInit {

  windowHeader = '';

  @Input() externalUrls: any[];

  constructor(public activeModal: NgbActiveModal,
              public translateService: TranslateService) {
  }

  ngOnInit() {
    this.windowHeader = this.translateService.translate("popup.many_sources_available");
  }

}
